import React, { ChangeEvent } from 'react';
import useStyle from './searchInput.style';

export interface SearchInputProps {
  value?: string;
  placeHolder: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput = ({
  value,
  placeHolder,
  onChange
}: SearchInputProps) => {
  const classes = useStyle();

  return (
    <input
      value={value}
      placeholder={placeHolder}
      className={classes.root}
      onChange={onChange}
      size={24}
      type="text"
    />
  );
};
